// ReturnOrders.js
import React, { useEffect, useState } from "react";
import { Table, Spin, message, Typography, Tag } from "antd";
import SummaryApi from "../../../common";
import axios from "axios";

const { Title } = Typography;

function ReturnOrders({ seller, token }) {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchReturnOrders();
  }, []);

  const fetchReturnOrders = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        SummaryApi.fetchReturnedOrders.url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            sellerId: seller.id,
          },
        }
      );
      setOrders(response.data.orders || []);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch returned orders");
    }
    setLoading(false);
  };

  const columns = [
    {
      title: "Order Number",
      dataIndex: "order_number",
      key: "order_number",
    },
    {
      title: "Customer Name",
      dataIndex: "customer_name",
      key: "customer_name",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    render: (amount) => `₹${Number(amount || 0).toFixed(2)}`,

    },
    {
      title: "Return Requested On",
      dataIndex: "return_requested_at",
      key: "return_requested_at",
      render: (date) => new Date(date).toLocaleString(),
    },
    {
      title: "Return Status",
      dataIndex: "return_status",
      key: "return_status",
      render: (status) => {
        let color = "orange";
        if (status === "approved") color = "green";
        else if (status === "rejected") color = "red";
        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      title: "Reason",
      dataIndex: "return_reason",
      key: "return_reason",
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Title level={3} style={{ marginBottom: "20px" }}>
        Returned Orders
      </Title>
      {loading ? (
        <Spin tip="Loading returned orders..." size="large" />
      ) : (
        <Table
          dataSource={orders}
          columns={columns}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />
      )}
    </div>
  );
}

export default ReturnOrders;
